import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const VIEW_OPTIONS = [
  { value: "week", label: "สัปดาห์" },
  { value: "month", label: "เดือน" },
];

const TimesheetToolbar = ({
  viewMode,
  rangeLabel,
  days = [],
  onViewChange,
  onPrevious,
  onNext,
  totalHours,
}) => {
  const formatThaiDate = (date) =>
    date.toLocaleDateString("th-TH", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  const formatThaiWeekday = (date) =>
    date.toLocaleDateString("th-TH", { weekday: "long" });
  const isWeeklyRange = viewMode === "week" && days.length >= 2;
  const detailedRangeLabel = isWeeklyRange
    ? `${formatThaiWeekday(days[0])}ที่ ${formatThaiDate(days[0])} - ${formatThaiWeekday(days[days.length - 1])}ที่ ${formatThaiDate(days[days.length - 1])}`
    : rangeLabel;

  return (
    <div className="grid gap-4 lg:grid-cols-[auto,1fr,auto] lg:items-center">
      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-1 inline-flex w-full sm:w-auto">
        {VIEW_OPTIONS.map((option) => {
          const active = option.value === viewMode;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onViewChange(option.value)}
              className={[
                "flex-1 sm:flex-none rounded-xl px-4 py-2 text-sm font-medium transition",
                active
                  ? "bg-indigo-500 text-white shadow-sm"
                  : "text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-300",
              ].join(" ")}
            >
              {option.label}
            </button>
          );
        })}
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={onPrevious}
          className="inline-flex items-center gap-2 rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-indigo-300 dark:hover:border-indigo-700"
        >
          <FiChevronLeft />
          ก่อนหน้า
        </button>

        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.18em] text-gray-400 dark:text-gray-500">
            ช่วงวันที่
          </p>
          <p className="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100">
            {detailedRangeLabel}
          </p>
          {isWeeklyRange && (
            <p className="mt-1 text-xs text-indigo-600 dark:text-indigo-300">
              รอบบันทึกประจำสัปดาห์ รวม {days.length} วัน
            </p>
          )}
        </div>

        <button
          type="button"
          onClick={onNext}
          className="inline-flex items-center gap-2 rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-indigo-300 dark:hover:border-indigo-700"
        >
          ถัดไป
          <FiChevronRight />
        </button>
      </div>

      <div className="rounded-2xl border border-indigo-100 dark:border-indigo-900/60 bg-indigo-50/70 dark:bg-indigo-500/10 px-4 py-3">
        <p className="text-xs uppercase tracking-[0.18em] text-indigo-500 dark:text-indigo-300">
          ชั่วโมงรวม
        </p>
        <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-gray-100">
          {totalHours}
        </p>
      </div>
    </div>
  );
};

export default TimesheetToolbar;
